import { UserPreferenceDestination } from './types'

export enum ModalSteps {
  mobileInitial = 'mobileInitial',
  holidayTypes = 'holidayTypes',
  destinations = 'destinations',
  hotelBrands = 'hotelBrands',
  travellers = 'travellers',
}

export const TRAVEL_PREFERENCES_DESTINATIONS: Array<UserPreferenceDestination> = [
  {
    name: 'Australia',
    placeId: 'le_d3d9446802a44259755d38e6d163e820',
    image: 'user-preferences-australia',

  },
  {
    name: 'Bali',
    placeId: 'le_64930b7151b6bc3e289f37d5da62ac9f',
    image: 'user-preferences-bali',
  },
  {
    name: 'Thailand',
    placeId: 'le_8f85517967795eeef66c225f7883bdcb',
    image: 'user-preferences-thailand',
  },
  {
    name: 'Fiji',
    placeId: 'le_72b32a1f754ba1c09b3695e0cb6cde7f',
    image: 'user-preferences-fiji',
  },
  {
    name: 'Maldives',
    placeId: 'le_2723d092b63885e0d7c260cc007e8b9d',
    image: 'user-preferences-maldives',
  },
  {
    name: 'Singapore',
    placeId: 'le_bd4c9ab730f5513206b999ec0d90d1fb',
    image: 'user-preferences-singapore',
  },
  {
    name: 'New Zealand',
    placeId: 'le_9fc3d7152ba9336a670e36d0ed79bc43',
    image: 'user-preferences-new-zealand',
  },
  {
    name: 'Vietnam',
    placeId: 'le_a597e50502f5ff68e3e25b9114205d4a',
    image: 'user-preferences-vietnam',
  },
  {
    name: 'Malta',
    placeId: 'le_698d51a19d8a121ce581499d7b701668',
    image: 'user-preferences-malta',
  },
  {
    name: 'United States of America',
    placeId: 'le_757b505cfd34c64c85ca5b5690ee5293',
    image: 'user-preferences-usa',
  },
  {
    name: 'Canada',
    placeId: 'le_c16a5320fa475530d9583c34fd356ef5',
    image: 'user-preferences-canada',
  },
  {
    name: 'Italy',
    placeId: 'le_93db85ed909c13838ff95ccfa94cebd9',
    image: 'user-preferences-italy',
  },
  {
    name: 'Cook Islands',
    placeId: 'le_3416a75f4cea9109507cacd8e2f2aefc',
    image: 'user-preferences-cook-islands',
  },
  {
    name: 'Malaysia',
    placeId: 'le_a3c65c2974270fd093ee8a9bf8ae7d0b',
    image: 'user-preferences-malaysia',
  },
  {
    name: 'United Arab Emirates',
    placeId: 'le_a2557a7b2e94197ff767970b67041697',
    image: 'user-preferences-united-arab-emirates',
  },
]
